import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UntilDestroy } from "@ngneat/until-destroy";
import { Navigate } from "@ngxs/router-plugin";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { PermitPaths } from "../../../permit-paths";

import { PermitStep } from "@ha/data/basic";
import { CurrentStep } from "../../../permit/models/current-step.model";
import { PermitStepActions } from "../../../permit/states/permit-step.action";
import { PermitStepSelectors } from "../../../permit/states/permit-step.selectors";
import { PermitCreateActions } from "../../states/permit-create.actions";
import { PermitCreateSelectors } from "../../states/permit-create.selectors";

@UntilDestroy()
@Component({
    selector: "pmt-is-flammable-hotwork",
    templateUrl: "permit-is-flammable-hot-work.component.html",
    styleUrls: ["permit-is-flammable-hot-work.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermitIsFlammableHotWorkComponent implements OnInit {
    @Select(PermitStepSelectors.currentStep)
    public currentStep$!: Observable<CurrentStep>;

    @Select(PermitCreateSelectors.isFlammableHotWork)
    public isFlammableHotWork$!: Observable<boolean>;

    public PermitStep = PermitStep;

    public isFlammableHotWork: boolean;

    public isFlammableWork: boolean;
    public isWorkplaceTemporary: boolean;

    public get canProceed() {
        const currentStep = this.store.selectSnapshot(PermitStepSelectors.currentStep);
        if (currentStep.step === this.PermitStep.isFlammableHotWork) {
            return this.isFlammableWork !== undefined;
        } else if (currentStep.step === this.PermitStep.isWorkplaceTemporary) {
            return this.isWorkplaceTemporary !== undefined;
        }
        return false;
    }

    constructor(private store: Store, private router: Router) {}

    public ngOnInit(): void {
        const isDemo = this.router.routerState.snapshot.url.includes(PermitPaths.CreateDemo);
        this.store.dispatch(new PermitCreateActions.SetIsDemo(isDemo));
    }

    public selectFlammableWork(isFlammableWork: boolean) {
        this.isFlammableWork = isFlammableWork;
    }

    public selectWorkplaceTemporary(isWorkplaceTemporary: boolean) {
        const isFlammableHotWork = this.store.selectSnapshot(PermitCreateSelectors.isFlammableHotWork);
        this.isWorkplaceTemporary = isWorkplaceTemporary;
        this.isFlammableHotWork = isFlammableHotWork && this.isWorkplaceTemporary;
    }

    public continue(): void {
        const currentStep = this.store.selectSnapshot(PermitStepSelectors.currentStep);

        if (currentStep.step === this.PermitStep.isWorkplaceTemporary) {
            if (this.isWorkplaceTemporary === undefined || this.isFlammableHotWork === undefined) {
                return;
            }
            this.store.dispatch(new PermitCreateActions.SetIsFlammableHotWork(this.isFlammableHotWork));
        } else if (currentStep.step === this.PermitStep.isFlammableHotWork) {
            if (this.isFlammableWork === undefined) {
                return;
            }
            this.store.dispatch(new PermitCreateActions.SetIsFlammableHotWork(this.isFlammableWork));
        }
    }

    public goBack(): void {
        const currentStep = this.store.selectSnapshot(PermitStepSelectors.currentStep);

        this.store.dispatch(new PermitStepActions.GoBackwards());
        if (currentStep.step === this.PermitStep.isFlammableHotWork) {
            this.store.dispatch(new Navigate([PermitPaths.Root]));
        }
    }
}
